import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash as privateIcon } from '@fortawesome/pro-regular-svg-icons';

import BrokerGrossCommissionInputs from './inputs';

import './styles.scss';

export default function BrokerGrossCommissionWrapper({
  children,
  commission,
  disabled,
  invalid,
  label,
  required,
  transactionSide,
  visibleOverflow
}) {
  return (
    <div
      className={classNames('form-group with-broker-gross-commission', {
        'has-error': invalid,
        'visible-overflow': visibleOverflow,
        required
      })}
    >
      <label className="control-label">
        {label}
      </label>

      <div className="form-input-container">
        {children}
        {disabled ?
          <span className="text-muted private-commission">
            <span className="mr-2">Private</span>
            <FontAwesomeIcon icon={privateIcon} />
          </span>
          :
          <BrokerGrossCommissionInputs commission={commission} transactionSide={transactionSide} />
        }
      </div>
    </div>
  );
}

BrokerGrossCommissionWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  commission: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  transactionSide: PropTypes.string,
  visibleOverflow: PropTypes.bool,
};
